export const SITE = {
  name: "M² Tuitions",
  tagline: "Personal • Group • Home Tuitions",
  phoneDisplay: "+91 63782 31794",
  phoneHref: "tel:+916378231794",
  email: "join.msquare@gmail.com",
  emailHref: "mailto:join.msquare@gmail.com",
  founded: 2016,
};

export const scrollToId = (id) => {
  const el = document.getElementById(id);
  if (!el) return false;
  const lenis = window.__lenis;
  if (lenis) lenis.scrollTo(el, { offset: -76, duration: 1.2 });
  else el.scrollIntoView({ behavior: "smooth" });
  return true;
};

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
